export default "__VITE_ASSET__B_eFmE2Y__"